// extracted by mini-css-extract-plugin
export default {"BottomNav":"BottomNav_BottomNav__5u40Y","hide":"BottomNav_hide__FNwOc"};